"use client";

import { getWebInstrumentations, initializeFaro, ReactIntegration } from "@grafana/faro-react";
import { useEffect } from "react";
import { GetAnalyticsVars } from "@patron/serverside/utils/servervars";

export const ObservabilityProviderWrapper = ({
  children,
  version,
  isAnalysticsEnabled = false,
}: {
  children: any;
  version: string;
  isAnalysticsEnabled?: boolean;
}) => {
  useEffect(() => {
    if (isAnalysticsEnabled) {
      GetAnalyticsVars().then((vars) => {
        if (!vars.analyticsEnabled) {
          return;
        }

        initializeFaro({
          url: vars.analyticsUrl,
          apiKey: vars.analyticsApiKey,
          trackWebVitalsAttribution: true,
          sessionTracking: {
            enabled: true,
            persistent: true,
          },
          app: {
            name: "patron",
            version: version,
          },
          instrumentations: [
            ...getWebInstrumentations({
              captureConsole: true,
            }),
            new ReactIntegration(),
          ],
        });
      });
    } else {
      return;
    }
  }, []);

  return children;
};
